// レンタル衣装・髪飾り・ヘアスタイリング・コラム のsingleページ用のJS
import Swiper from "swiper/bundle";

export const singlePage = () => {
  const itemImgThumbSlider = new Swiper(".item-img-thumb-slider", {
    loop: false,
    spaceBetween: 14,
    slidesPerView: 6,
    freeMode: true,
    direction: "vertical",
    autoHeight: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: false,
  });

  const itemImgMainSlider = new Swiper(".item-img-main-slider", {
    loop: false,
    spaceBetween: 14,
    slidesPerView: 1,
    watchOverflow: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-prev",
      prevEl: ".swiper-button-next",
    },
    thumbs: {
      swiper: itemImgThumbSlider,
    },
  });

  const recommendItemsSlider = new Swiper(".recommend-items-slider", {
    slidesPerView: 2.2,
    spaceBetween: 16,
    breakpoints: {
      1024: {
        slidesPerView: "auto",
        spaceBetween: 40,
      },
    },
  });
};
